/**
 * Operator-facing transport label: the persisted human-readable
 * `displayLabel` (e.g. `TR-ZK-4/08/2026-1`, `TR-ZD/2026/03/1-2`), falling back
 * to the legacy `routeNumber` for rows without one. The label rule itself is
 * owned by the backend (`backend/src/utils/transportDisplayLabel.js`); render
 * transports through this helper instead of reading `routeNumber` directly.
 */
export interface TransportLabelSource {
  displayLabel?: string | null;
  routeNumber?: string | null;
}

export function getTransportLabel(
  transport: TransportLabelSource | null | undefined,
  fallback = '',
): string {
  const label = transport?.displayLabel?.trim() || transport?.routeNumber?.trim();
  return label || fallback;
}
